import React, { FC, useEffect, useState } from "react";
import cx from "classnames";
import moment from "moment";
import { jsPDF } from "jspdf";
import printJS from "print-js";

// icons
import PrintIcon from "@material-ui/icons/Print";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ModeEditIcon from "@mui/icons-material/ModeEdit";

// styles
import styles from "./OrderDetails.module.scss";

// components
import ProductsTable from "./components/productsTable/ProductsTable";
import OrderStatusUpdateButton from "../orderStatusUpdateButton/OrderStatusUpdateButton";
import LoadingComponent from "../../loadingComponent/LoadingComponent";

//api
import apis from "../../../api/apis";
import {
  orderRequestModel,
  statusForBtnsRequestModel,
} from "../../../api/apiRequestObjects";

//config
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import { notifyError } from "../../../config/toastNotification";

//interface
import {
  IOrderStatus,
  IPartnerOrder,
  IPartnerOrderDetail,
} from "../../../interfaces/order";
import { useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { Stack } from "@mui/material";
import { ArrowBack } from "@material-ui/icons";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import SnackBar, { SnackBarModel } from "../../snackBar/SnackBar";
import PatchCart from "./components/patchCart/PatchCart";

//sample data
const sampleItems = [
  {
    name: "Item 1",
    quantity: 5,
    price: 10,
    id: "1",
  },

  {
    name: "Item 2",
    quantity: 4,
    price: 40,
    id: "2",
  },
  // {
  //   name: "Item 3",
  //   quantity: 2,
  //   price: 100,
  //   id: "3",
  // },
  // {
  //   name: "Item 4",
  //   quantity: 2,
  //   price: 10,
  //   id: "4",
  // },
];

interface IProps {
  posOrderStatus: IOrderStatus[];
  selectedItem: IPartnerOrder;
  updateOrder: (
    updatedOrderStatus: IOrderStatus,
    selectedOrder: IPartnerOrder
  ) => void;
  handleBillPrinting: (
    partnerOrderId: number | undefined,
    orderReference: string | undefined
  ) => void;
}

const OrderDetails: FC<IProps> = ({
  selectedItem,
  posOrderStatus,
  updateOrder,
  handleBillPrinting,
}) => {
  //console.log(selectedItem);
  const [partnerOrder, setPartnerOrder] = useState<IPartnerOrder>();
  const [statusForBtn, setStatusForBtn] = useState<IOrderStatus[]>();
  //console.log(partnerOrder);
  const [isOrderDetailsLoading, setIsOrderDetailsLoading] = useState(false);
  //snack bar model
  const [snackBarmodel, setSnackBarModel] = useState<SnackBarModel>({
    openSnackBar: false,
    msg: "",
    autoHideDuration: 6000,
  });

  //patch related states
  const [togglePatchCart, setTogglePatchCart] = useState<boolean>(false);
  const handlePatchCartSetup = (orderItem: IPartnerOrderDetail) => {
    setTogglePatchCart(true);
  };
  //const [showDispatch, setshowDispatch] = useState<boolean>(false);
  /*   const [expand, setexpand] = useState<boolean>(false);
  const [rowId, setrowId] = useState<string>("");
  const [stock, setstock] = useState<string>("");
  const [fulfilmentType, setfulfilmentType] = useState<string>("");
  const [selectedCount, setselectedCount] = useState<string[]>([]); */

  //get redux state
  const { user } = useSelector((state: any) => state.authentication);

  useEffect(() => {
    const fetchData = async () => {
      try {
        //setIsOrderDetailsLoading(true);
        orderRequestModel.UID.UserKey = user.UserKey;
        orderRequestModel.UID.LocationKey = user.LocationKey;
        orderRequestModel.UID.CompanyKey = user.CompanyKey;
        orderRequestModel.UID.EnvironmentName = user.EnvironmentName;

        orderRequestModel.PartnerOrderId = selectedItem.PartnerOrderId;
        const response = await apis.Orders.fetchPartnerOrder(orderRequestModel);
        //console.log(response);
        if (response.ResponseType === APIResponseType.Success) {
          //console.log(response.ResponseData.AllOrders);
          setPartnerOrder(response.ResponseData.PartnerOrder);
          //console.log(setOrderList(response.ResponseData.AllOrders));
          setIsOrderDetailsLoading(false);
          // console.log(partnerOrder);
          //console.log(selectedItem);
        } else {
          console.log("api fetching error");
          setIsOrderDetailsLoading(false);
        }
      } catch (e) {
        notifyError();
        console.log(e);
      }
    };

    fetchData();
  }, [selectedItem.PartnerOrderId]);

  //fetch Order Status for Button
  useEffect(() => {
    const fetchOrderStatusBtnData = async () => {
      try {
        setIsOrderDetailsLoading(true);
        statusForBtnsRequestModel.UID.UserKey = user.UserKey;
        statusForBtnsRequestModel.UID.LocationKey = user.LocationKey;
        statusForBtnsRequestModel.UID.CompanyKey = user.CompanyKey;
        statusForBtnsRequestModel.UID.EnvironmentName = user.EnvironmentName;

        statusForBtnsRequestModel.POSStatusKey =
          partnerOrder?.OrderDelivery.OrderStatus.POSStatusKey ??
          selectedItem.OrderDelivery.OrderStatus.POSStatusKey;
        //if (prevSelectedNavItemRef.current !== selectedNavItem) {
        if (statusForBtnsRequestModel.POSStatusKey > 0) {
          const response = await apis.Orders.fetchOrderStatusForBtn(
            statusForBtnsRequestModel
          );
          //console.log(response);
          if (response.ResponseType === APIResponseType.Success) {
            setStatusForBtn(response.ResponseData.OrderStatusList);
            setIsOrderDetailsLoading(false);

            /*             response.ResponseData.OrderStatusList.forEach((orderStatus) => {
              statusForBtn.find(
                (e) => e.POSStatusKey === orderStatus.POSStatusKey
              ) === undefined && statusForBtn.push(orderStatus);
            });
            console.log(statusForBtn); */
            //prevSelectedNavItemRef.current = selectedNavItem;
            //setStatusForBtn(...statusForBtn, orde);
          } else {
            console.log("api fetching error");
            setIsOrderDetailsLoading(false);
          }
          //}
        }
      } catch (e) {
        notifyError();
        console.log(e);
      }
    };

    fetchOrderStatusBtnData();
  }, [partnerOrder, selectedItem]);

  //method to convert base64string to blob
  /*   const base64ToBlob = async (encoded: string) => {
    let url = `data:application/pdf;base64,${encoded}`;
    let res = await fetch(url);
    let blob = await res?.blob();
    return blob;
  }; */

  const handleKOTPrint = async (KOTReportSource: string | undefined) => {
    //var imgData = "data:image/jpeg;base64," + KOTReportSource;
    //var doc = new jsPDF();

    //doc.addImage(imgData, "JPEG", 15, 40, 180, 160);

    //window.open(doc.output("datauristring"));
    //doc.output("dataurlnewwindow");

    /*    setSnackBarModel({
      openSnackBar: true,
      msg: "Loading for Printing Please Wait !",
    }); */

    //Build a URL from the file
    if (KOTReportSource !== undefined) {
      //console.log(KOTReportSource);
      //const res = await window.fetch(KOTReportSource);
      //const base64 = await fetch(KOTReportSource);
      try {
        const base64Response = await fetch(
          `data:application/pdf;base64,${KOTReportSource}`
        );
        const blob = await base64Response.blob();
        //const blob = await res.blob();
        const fileURL = URL.createObjectURL(blob);
        //console.log(b64toBlob(KOTReportSource));
        printJS(fileURL);
      } catch (e) {
        console.log("fetch error", e);
        //show error msg
        setSnackBarModel({
          openSnackBar: true,
          msg: "Error: Report Source Not Found !",
          autoHideDuration: 6000,
        });
      }
    } else {
      //show error msg
      setSnackBarModel({
        openSnackBar: true,
        msg: "Error: Report Source Not Found !",
        autoHideDuration: 6000,
      });
    }
  };

  //console.log("selectedItemOrderDetails", selectedItem);

  //if (isOrderDetailsLoading) return <LoadingComponent />;

  /*   const stockAvailability = (e: any) => {
    const { value } = e.target;
    setstock(value);
  };

  const handleFulfilment = (e: any) => {
    const { value } = e.target;
    setfulfilmentType(value);
  };

  const stockChange = (e: any, itemdetails: any) => {
    const { checked } = e.target;
    console.log(itemdetails.OrderItem.ItemCode);
    if (checked === true) {
      setselectedCount((prev: any) => [
        ...prev,
        itemdetails.OrderItem.ItemCode,
      ]);
    }
    if (checked === false) {
      const index = selectedCount.indexOf(itemdetails.OrderItem.ItemCode);
      console.log(index);
      // setselectedCount((prev: any) => [
      //   ...prev,
      //   selectedCount.splice(index, 1),
      // ]);

      selectedCount.splice(index, 1);
    }
  }; */

  // useEffect(() => {
  //   if (partnerOrder?.OrderDelivery.OrderStatus.POSStatusName === "Confirmed") {
  //     //window.alert("print KOT");
  //     console.log(partnerOrder?.KOTReportSource);
  //     handleKOTPrint(partnerOrder?.KOTReportSource);
  //   }
  // }, [
  //   partnerOrder?.OrderDelivery.OrderStatus.POSStatusName,
  //   partnerOrder?.KOTReportSource,
  // ]);

  return (
    <>
      <div className={styles.order_details_container}>
        {/* row 1 */}
        <div className={styles.row1}>
          <div className={styles.product_id}>
            <div className={styles.title}>Order Id</div>
            <div className={styles.content}>
              {"#" + partnerOrder?.OrderReference}
            </div>
          </div>
          <div className={styles.order_type}>
            <div className={styles.title}>Order Type</div>
            <div className={styles.content}>
              {partnerOrder?.OrderDelivery?.TypeOfOrder.OrderTypeName}
            </div>
          </div>
          <div className={styles.placed_at}>
            <div className={styles.title}>Placed At</div>
            <div className={styles.content}>
              {moment(partnerOrder?.OrderDate).format("DD-MM-YYYY, h:mm:ss a")}
            </div>
          </div>
        </div>

        <div className={styles.row3}>
          <div className={styles.customer_details}>
            <div className={styles.title}>Customer</div>
            <div className={styles.content}>
              <div>{partnerOrder?.Customer.Name}</div>
              <div>{partnerOrder?.Customer.Phone}</div>
              <div>{partnerOrder?.Customer.Address}</div>
            </div>
          </div>
          <div className={styles.order_comments}>
            <div className={styles.title}>Order Comment</div>
            <div className={styles.content}>{partnerOrder?.OrderNote}</div>
          </div>
          <div className={styles.status_and_payment_container}>
            <div className={styles.order_status}>
              <div className={styles.title}>Current Order Status</div>
              <div className={styles.content}>
                {partnerOrder?.OrderDelivery.OrderStatus.POSStatusName}
              </div>
            </div>
            <div className={styles.payment_type}>
              <div className={styles.title}>Delivery time</div>
              <div className={styles.content}>
                {moment(partnerOrder?.PickupTime).format(
                  "DD-MM-YYYY, h:mm:ss a"
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.row4}>
          <ProductsTable orderItems={partnerOrder?.OrderItemDetails} />
        </div>

        <div className={styles.row5}>
          <div className={styles.col1}>
            <div className={styles.price_item}>
              <span>Sub Total</span>
              <span>{partnerOrder && partnerOrder.Amount.toFixed(2)}</span>
            </div>
            <div className={styles.price_item}>
              <span>Discount</span>
              <span>{partnerOrder?.DiscountAmount.toFixed(2)}</span>
            </div>
            <div className={styles.price_item}>
              <span>Taxes</span>
              <span>{partnerOrder?.TaxAmount.toFixed(2)}</span>
            </div>
            <div className={styles.price_item}>
              <span>Charges</span>
              <span>{partnerOrder?.ChargesAmount.toFixed(2)}</span>
            </div>
          </div>
          <div className={styles.col2}>
            <div className={cx(styles.price_item, styles.border)}>
              <span>Total</span>
              <span>
                {partnerOrder &&
                  (
                    partnerOrder.Amount +
                    partnerOrder.ChargesAmount +
                    partnerOrder.TaxAmount -
                    partnerOrder.DiscountAmount
                  ).toFixed(2)}
              </span>
            </div>
            {partnerOrder?.OrderItemDetails.filter(
              (item: IPartnerOrderDetail) => item.IsPayment === true
            ).map((order: IPartnerOrderDetail) => (
              <div className={styles.price_item}>
                <span>{order.OrderItem.ItemName}</span>
                <span>
                  {(order.TransactionPrice * order.ItemQuantity).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.row6}>
          {selectedItem &&
            statusForBtn !== undefined &&
            statusForBtn.length > 0 &&
            !selectedItem.OrderDelivery.OrderStatus.IsCompletedOrderStatus && (
              <div className={styles.patch}>
                {/* <ModeEditIcon
                  fontSize="medium"
                  onClick={() => setTogglePatchCart(true)}
                /> */}
                {/* <div>PATCH</div> */}
              </div>
            )}
          <div className={styles.kot}>
            <EventAvailableIcon
              fontSize="medium"
              onClick={() => handleKOTPrint(partnerOrder?.KOTReportSource)}
            />
            <div>KOT</div>
          </div>
          <div className={styles.print}>
            <PrintIcon
              fontSize="medium"
              onClick={() =>
                handleBillPrinting(
                  partnerOrder?.PartnerOrderId,
                  partnerOrder?.OrderReference
                )
              }
            />
            <div>Print</div>

            {/* <button onClick={() => setshowDispatch(true)}>Patch</button> */}
          </div>
          <div className={styles.item_next_status}>
            {isOrderDetailsLoading ? (
              <LoadingComponent />
            ) : (
              selectedItem &&
              statusForBtn !== undefined &&
              statusForBtn.length > 0 &&
              !selectedItem.OrderDelivery.OrderStatus
                .IsCompletedOrderStatus && (
                <OrderStatusUpdateButton
                  statusForBtn={statusForBtn}
                  selectedOrder={selectedItem}
                  updateOrder={updateOrder}
                  partnerOrderId={partnerOrder?.PartnerOrderId}
                  posOrderStatus={posOrderStatus}
                />
              )
            )}
          </div>
        </div>
      </div>
      {/*patch cart toggle*/}
      {togglePatchCart && (
        <PatchCart
          orderId={partnerOrder?.OrderId}
          orderTypeCode={partnerOrder?.OrderDelivery.TypeOfOrder.OrderTypeCode}
          orderItems={partnerOrder?.OrderItemDetails}
          onClick={() => setTogglePatchCart(false)}
        />
      )}
      {snackBarmodel.openSnackBar && <SnackBar snackBarModel={snackBarmodel} />}
    </>
  );
};

export default OrderDetails;
